import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { RouterModule } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { AppComponent } from './app/app.component';

const routes = [
  { path: '', loadComponent: () => import('./app/landing/landing.component').then(m => m.LandingComponent) },
  { path: 'community-register', loadComponent: () => import('./app/components/community-register/community-register.component').then(m => m.CommunityRegisterComponent) },
  { path: '**', redirectTo: '' }
];

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(RouterModule.forRoot(routes)),
    provideHttpClient()
  ]
})
.catch(err => console.error(err));
